import { useState } from 'react';
import { useAppStore } from '../../store/store';
import s from './PricingRadio.module.css';
export const PricingRadio = props => {
  const { value1, value2, name } = props;
  const [storage, setStorage] = useState(value1);
  const { setScalewayVariant, setBunnyVariant } = useAppStore();

  const onRadioChange = event => {
    setStorage(event.target.value);

    if (name === 'scaleway') {
      setScalewayVariant(event.target.value);
    }
    if (name === 'bunny') {
      setBunnyVariant(event.target.value);
    }
  };
  return (
    <div className={s.container}>
      <label className={s.labela}>
        <input
          className={s.inputg}
          type="radio"
          name={name}
          value={value1}
          id={value1}
          checked={storage === value1}
          onChange={onRadioChange}
        />
        <span className={s.spang}>{value1}</span>
      </label>
      <label className={s.labela}>
        <input
          className={s.inputg}
          type="radio"
          name={name}
          value={value2}
          id={value2}
          checked={storage === value2}
          onChange={onRadioChange}
        />
        <span className={s.spang}>{value2}</span>
      </label>
    </div>
  );
};
